/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  Divider,
  Form,
  Input,
  Button,
  Flex,
  Card,
  Table,
  Typography,
} from "antd";
import { Row, Col, Space } from "antd";

import {
  SaveFilled,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import {
  componentsEditable,
  columnsMicroParametersEditable,
  defaultParamenterMicro,
} from "./modal-microbiological.model";

/* source = ข้อมูลเดิมตอนแก้ไข (ไม่ส่งมา = สร้างใหม่) */
const ModalMicrobiologicalManage = ({ submit, source = null }) => {
  const [form] = Form.useForm();
  const isEdit = !!source?.micro_code;

  const [parametersMicro, setParametersMicro] = useState(
    isEdit ? [] : defaultParamenterMicro
  );

  useEffect(() => {
    if (!isEdit) return;
    form.setFieldsValue({ micro_master_name: source.micro_master_name });
    setParametersMicro(
      (source.detail || []).map((d, i) => ({ ...d, seq: i + 1 }))
    );
  }, [source]);

  const handleConfirm = () => {
    form.validateFields().then(() => {
      const header = { ...form.getFieldsValue() };
      if (isEdit) header.micro_code = source.micro_code;
      /* detail ต้องเป็น array ไม่ใช่ object (เดิมใช้ {...array} ทำให้กลายเป็น object) */
      const payload = { header, detail: [...parametersMicro] };
      submit(payload, isEdit);
    });
  };

  const handleAddParameter = () => {
    setParametersMicro([
      ...parametersMicro,
      {
        seq: parametersMicro.length + 1,
        parameter: `parameter ${parametersMicro.length + 1}`,
        limit_number: null,
        unit: null,
        remark: null,
      },
    ]);
  };

  const Detail = () => (
    <Row gutter={[8, 8]} className="px-2 sm:px-4 md:px-4 lg:px-4">
      <Col xs={24} sm={24} md={24} lg={14} xl={14} xxl={14}>
        <Form.Item
          label="Microbiological Name"
          name="micro_master_name"
          rules={[{ required: true, message: "Please enter data!" }]}
        >
          <Input placeholder="Enter Microbiological Name" />
        </Form.Item>
      </Col>
    </Row>
  );

  const SectionBottom = (
    <Row
      gutter={[{ xs: 32, sm: 32, md: 32, lg: 12, xl: 12 }, 8]}
      className="m-0"
    >
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start">
          {/* <ButtonBack target={from} /> */}
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={4} justify="end">
          <Button
            icon={<SaveFilled style={{ fontSize: "1rem" }} />}
            type="primary"
            style={{ width: "9.5rem" }}
            onClick={() => {
              handleConfirm();
            }}
          >
            {isEdit ? "Save" : "Create"}
          </Button>
        </Flex>
      </Col>
    </Row>
  );

  const SectionChooseMicro = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            Microbiological Specification
          </Typography.Title>
        </Flex>
      </Col>
      {/* <Col span={12} style={{paddingInline:0}}>
                <Flex gap={4} justify='end'>
                      <Button  
                      size='small' 
                      className='bn-action bn-center bn-primary-outline justify-center'  
                      icon={<FileAddOutlined  style={{fontSize:'.9rem'}} />} 
                      // onClick={() => { 
                      //   setIsOpenModalMicro(true) 
                      // } } 
                      >
                          Select Microbiological
                      </Button>
                </Flex>
            </Col>   */}
    </Flex>
  );

  const handleDelete = (seq) => {
    const newData = parametersMicro
      .filter((val) => val?.seq !== seq)
      .map((m, i) => ({ ...m, seq: i + 1 }));
    setParametersMicro([...newData]);
  };

  const handleAction = (record) => {
    return parametersMicro.length >= 1 ? (
      <Button
        className="bt-icon"
        size="small"
        danger
        icon={<DeleteOutlined />}
        onClick={() => handleDelete(record.seq)}
      />
    ) : null;
  };

  const handleSave = (row) => {
    const newData = (r) => {
      const newData = [...parametersMicro];

      const ind = newData.findIndex((item) => row.seq === item?.seq);
      const item = newData[ind];

      newData.splice(ind, 1, {
        ...item,
        ...row,
      });
      return newData;
    };
    setParametersMicro([...newData()]);
  };

  const columnMicrobiological = columnsMicroParametersEditable(handleSave, {
    handleAction,
  });

  return (
    <div className="supplier-manage xs:px-0 sm:px-0 md:px-8 lg:px-8">
      <Space direction="vertical" className="flex gap-2">
        <Form form={form} layout="vertical" autoComplete="off">
          <Divider orientation="left" plain style={{ margin: 10 }}>
            {" "}
            Information Detail{" "}
          </Divider>
          <Detail />
        </Form>
        <Divider orientation="left" plain style={{ margin: 10 }}>
          {" "}
          Parameter Detail{" "}
        </Divider>
        <Card>
          <Space
            direction="vertical"
            size="middle"
            style={{ display: "flex", position: "relative" }}
            className="sample-request-modal"
          >
            <Table
              title={() => SectionChooseMicro}
              components={componentsEditable}
              rowClassName={() => "editable-row"}
              bordered
              dataSource={parametersMicro || []}
              columns={columnMicrobiological}
              pagination={false}
              rowKey="seq"
              locale={{
                emptyText: (
                  <span>No data available, please add some data.</span>
                ),
              }}
              scroll={{ x: "max-content" }}
              size="small"
            />
            <Row style={{ paddingInline: 14 }}>
              <Col
                span={24}
                style={{ display: "flex", justifyContent: "center" }}
                className="width-100 append-step"
              >
                <Button
                  shape="circle"
                  icon={<PlusCircleOutlined />}
                  style={{
                    width: "2.5rem",
                    boxShadow: "none",
                    lineHeight: "2.5rem",
                  }}
                  onClick={() => {
                    handleAddParameter();
                  }}
                ></Button>
              </Col>
            </Row>
          </Space>
        </Card>
        {SectionBottom}
      </Space>
    </div>
  );
};

export default ModalMicrobiologicalManage;
